<template>
  <b-form-group :label="form_group_label">

    <b-form-group :label="$t('components.exam_form.nome')" label-for="exam_name" v-if="exam_name">
      <b-input id="exam_name" :disabled="isTuevs" :value="exam_name"></b-input>
    </b-form-group>

    <b-form-group :label="$t('components.exam_form.codigo')" label-for="exam_code" v-if="exam_code">
      <b-input id="exam_code" :disabled="isTuevs" :value="exam_code"></b-input>
    </b-form-group>

    <b-collapse :id="collapseId" :visible="!isTuevs">
      <b-form-group :label="$t('components.exam_form.componente')" label-for="component" v-if="component">
        <b-input id="component" :disabled="isTuevs" :value="component"></b-input>
      </b-form-group>

      <b-form-group :label="$t('components.exam_form.material')" label-for="material" v-if="material">
        <b-input id="material" :disabled="isTuevs" :value="material"></b-input>
      </b-form-group>

      <b-form-group :label="$t('components.exam_form.metodo')" label-for="method" v-if="method">
        <b-input id="method" :disabled="isTuevs" :value="method"></b-input>
      </b-form-group>

      <b-form-group :label="$t('components.exam_form.tempo')" label-for="time" v-if="time">
        <b-input id="time" :disabled="isTuevs" :value="time"></b-input>
      </b-form-group>

      <b-form-group :label="$t('components.exam_form.escala')" label-for="scale" v-if="scale">
        <b-input id="scale" :disabled="isTuevs" :value="scale"></b-input>
      </b-form-group>
    </b-collapse>

  </b-form-group>
</template>

<script>
export default {
  name: "ExamForm",
  props: {
    isTuevs: Boolean,
    form_group_label: String,
    exam_name: String,
    exam_code: String,
    component: String,
    material: String,
    method: String,
    time: String,
    scale: String,
    collapseId: {
      type: String,
      default: 'hideInfo'
    },
    data: {
      type: Object
    },
  }
}
</script>

<style scoped>
</style>